<template>
  <div>
    <el-form :model="liveInfo" ref="liveInfo">
      <!--<el-form-item label="班级类型" label-width="100px" prop="Title">-->
        <!--<el-radio-group v-model="liveInfo.courseMasterType" :disabled="isAdd === false" @change="courseMasterTypeChange">-->
          <!--<el-radio v-for="item in this.courseMasterTypeList" :label="item.value">{{item.label}}</el-radio>-->
        <!--</el-radio-group>-->
      <!--</el-form-item>-->
      <!--<el-form-item v-if="liveInfo.courseMasterType === 1" label="主班级" label-width="100px" prop="Title">-->
        <!--<span v-if="(this.selectMasterFlag || liveInfo.MasterId !== 0)" style="margin-right: 20px">{{this.selectMasterClassTitle === '' ? this.liveInfo.MasterName : this.selectMasterClassTitle}}</span>-->
        <!--<el-button size="small" icon="el-icon-plus" @click="addMasterClass">{{(this.selectMasterFlag || liveInfo.MasterId !== 0)? '修改' : '选择主班级'}}</el-button>-->
      <!--</el-form-item>-->
      <el-form-item label="子班名称" label-width="100px" prop="Title">
        <el-input v-model="liveInfo.SubClassName" maxlength="4"></el-input>
      </el-form-item>
      <el-form-item label="直播名称" label-width="100px" prop="Title">
        <el-input v-model="liveInfo.Title"></el-input>
      </el-form-item>
      <el-form-item label="直播时间" label-width="100px" prop="Title">
        <el-date-picker style="width: 200px"
                        v-model="liveInfo.BeginTime"
                        type="datetime"
                        placeholder="开始时间"
                        :disabled="true"
                        :picker-options="beginTimePickerOptions">
        </el-date-picker>
        <el-date-picker style="width: 200px"
                        v-model="liveInfo.EndTime"
                        type="datetime"
                        placeholder="结束时间"
                        :disabled="true"
                        :picker-options="endTimePickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="辅导老师" label-width="100px" prop="Title">
        <el-tag style="margin-right: 5px"
                v-for="item in liveInfo.Teachers"
                closable
                @close="handleCloseTeacher(item)">
          {{item.Name}}
        </el-tag>
        <el-button size="small" icon="el-icon-plus" @click="addTeacher">选择授课老师</el-button>
      </el-form-item>
      <el-form-item label="助教" label-width="100px" prop="Title">
        <el-tag style="margin-right: 5px"
                :key="item"
                v-for="item in liveInfo.Assistants"
                closable
                @close="handleCloseAssistant(item)">
          {{item.Name}}
        </el-tag>
        <el-button size="small" icon="el-icon-plus" @click="addAssistant">选择助教</el-button>
      </el-form-item>
      <!--<el-form-item label="课件云盘资源" label-width="100px" prop="Title">-->
        <!--<el-input v-model="liveInfo.CloudDiskFiles"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="直播描述" label-width="100px">
        <el-input v-model="liveInfo.Detail"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <div style="padding-top: 10px;padding-left: 30px">
      <el-button @click="cancleBtnClick">取 消</el-button>
      <el-button type="primary" @click="okBtnClick">确 定</el-button>
    </div>
    <el-dialog title="添加老师" :visible.sync="dialogAddTeacherVisible" append-to-body @close="closeTeacherDialog">
      <select-user-component ref="addTeacherView"
                             :showSearch="false"
                             @selected="teacherSelect"
                             @searchUnSelectClick="teacherSearchUnSelectClick"
                             @searchSelectClick="teacherSearchSelectClick"
                             @unSelected="teacherNnSelected"></select-user-component>
    </el-dialog>
    <el-dialog title="添加助教" :visible.sync="dialogAddAssistantVisible" append-to-body @close="closeAssistantDilog">
      <select-user-component :showSearch="false" ref="addAssistantView" @selected="assistantSelect" @unSelected="assistantNnSelected"></select-user-component>
    </el-dialog>
    <el-dialog title="选择主教室" style="width: 100%;" :visible.sync="dialogMasterClassListVisible" append-to-body>
      <double-tea-master-list-component ref="masterClassListComponent" @selectMasterClass="selectMasterClass"></double-tea-master-list-component>
    </el-dialog>
  </div>
</template>

<script>
  import SelectUserComponent from '../selectuser/SelectUserComponent'
  import DoubleTeaMasterListComponent from './DoubleTeaMasterListComponent'
  export default {
    name: 'AddDoubleTeaLiveComponent',
    components: {DoubleTeaMasterListComponent, SelectUserComponent},
    props: {
      liveInfo: {
        required: false
      },
      isAdd: {
        default: true
      }
    },
    data () {
      return {
        dialogAddTeacherVisible: false,
        allTeacherList: [],
        dialogAddAssistantVisible: false,
        allAssistantList: [],
        courseMasterTypeList: [{label: '主教室', value: 0}, {label: '子教室', value: 1}],
        dialogMasterClassListVisible: false,
        selectMasterClassTitle: '',
        selectMasterFlag: false,
        beginTimePickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '明天',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }],
          disabledDate: this.startTimeDisableData
        },
        endTimePickerOptions: {
          disabledDate: this.endTimeDisableData
        }
      }
    },
    methods: {
      // endTimeSelectableRange () {
      //   debugger
      //   let str = '00:00:00 - ' + this.formatDate('HH:MM:SS', this.liveInfo.BeginTime)
      //   console.log(str)
      //   return str
      // },

      startTimeDisableData (time){
        if (time.getTime() < new Date().getTime() - 3600 * 1000 * 24) {
          return true
        } else {
          return false
        }
      },
      endTimeDisableData (time) {
        if (time.getTime() > this.liveInfo.BeginTime.getTime() + 3600 * 1000 * 24) {
          return true
        } else if (time.getTime() < this.liveInfo.BeginTime.getTime() - 3599 * 1000 * 24) {
          return true
        } else {
          return false
        }
      },
      getMasterClassName () {
        debugger
      },
      cancleBtnClick () {
        this.$emit('CancleBtnClick')
      },
      okBtnClick () {
        if (this.liveInfo.courseMasterType === 1 && (this.liveInfo.masterId === undefined)){
          this.$message.error('请选择主教室')
          return
        }
        if (this.liveInfo.BeginTime === undefined){
          this.$message.error('请选择开始时间')
          return
        }
        if (this.liveInfo.EndTime === undefined){
          this.$message.error('请选择结束时间')
          return
        }
        if (this.liveInfo.BeginTime.getTime() > this.liveInfo.EndTime.getTime()) {
          this.$message.error('结束时间要大于开始时间')
          return
        }
        if (this.liveInfo.BeginTime.getTime() < this.liveInfo.EndTime.getTime() - 3600 * 1000 * 24 - 1000) {
          this.$message.error('直播时间不能超过一天')
          return
        }
        if (this.liveInfo.SubClassName === undefined || this.liveInfo.SubClassName.length === 0){
          this.$message.error('请填写班级名称')
          return
        }
        this.selectMasterFlag = false
        this.selectMasterClassTitle = ''
        this.$emit('OKBtnClick')
      },
      addMasterClass () {
        this.dialogMasterClassListVisible = true
        if (this.$refs.masterClassListComponent !== undefined) {
          this.$refs.masterClassListComponent.getMasterClassList()
        } else {
          // let that = this
          // setTimeout(function () {
          //   that.$refs.masterClassListComponent.getMasterClassList()
          // },100)
        }
      },
      selectMasterClass (masterLive) {
        this.dialogMasterClassListVisible = false
        this.selectMasterFlag = true
        this.liveInfo.masterId = masterLive.Id
        this.selectMasterClassTitle = masterLive.Title
        debugger
        this.liveInfo.BeginTime = new Date(masterLive.BeginTime)
        this.liveInfo.EndTime = new Date(masterLive.EndTime)

      },
      courseMasterTypeChange () {
        console.log(this.liveInfo)
      },
      closeTeacherDialog () {
        this.$refs.addTeacherView.release()
      },
      addTeacher () {
        this.dialogAddTeacherVisible = true
        this.getAllTeacher(1000, 1)
        this.$refs.addTeacherView.setSelectList(this.liveInfo.Teachers)
      },
      handleCloseTeacher (item) {
        this.remoteTeacher(this.liveInfo.Teachers, item)
      },
      teacherSelect (item) {
        this.liveInfo.Teachers.push(item)
        this.$refs.addTeacherView.selectedSuccess(item)
      },
      teacherNnSelected (item) {
        this.remoteTeacher(this.liveInfo.Teachers, item)
        this.$refs.addTeacherView.unSelectedSuccess(item)
      },
      getAllTeacher (count, page) {
        let requestData = {count: count, page: page}
        this.$api.userManager.getTeacherList(requestData).then((res) => {
          if (res.code === 0) {
            this.allTeacherList = res.data
            for (let i = 0; i < this.liveInfo.Teachers.length; i++) {
              let hasItem = this.liveInfo.Teachers[i]
              this.remoteTeacher(this.allTeacherList, hasItem)
            }
            this.$refs.addTeacherView.setUnSelectList(this.allTeacherList)
          }
        })
      },
      remoteTeacher (array, item) {
        // debugger
        for (let i = 0; i < array.length; i++) {
          let tmp = array[i]
          if (tmp.Id === item.Id) {
            array.splice(i, 1)
            return
          }
        }
      },
      teacherSearchSelectClick (searchKey) {
        let resArray = this.searchKeyByArray(searchKey, this.liveInfo.Teachers)
        this.$refs.addTeacherView.setSelectList(resArray)
      },
      teacherSearchUnSelectClick (searchKey) {

      },
      closeAssistantDilog () {
        this.$refs.addAssistantView.release()
      },
      addAssistant () {
        this.dialogAddAssistantVisible = true
        this.getAllAssistant(1000, 1)
        this.$refs.addAssistantView.setSelectList(this.liveInfo.Assistants)
      },
      handleCloseAssistant (item) {
        this.remoteAssistant(this.liveInfo.Assistants, item)
      },
      assistantSelect (item) {
        this.liveInfo.Assistants.push(item)
        this.$refs.addAssistantView.selectedSuccess(item)
      },
      assistantNnSelected (item) {
        this.remoteAssistant(this.liveInfo.Assistants, item)
        this.$refs.addAssistantView.unSelectedSuccess(item)
      },
      getAllAssistant (count, page) {
        let requestData = {count: count, page: page}
        this.$api.userManager.getAssistantList(requestData).then((res) => {
          if (res.code === 0) {
            this.allAssistantList = res.data
            for (let i = 0; i < this.liveInfo.Assistants.length; i++) {
              let hasItem = this.liveInfo.Assistants[i]
              this.remoteAssistant(this.allAssistantList, hasItem)
            }
            this.$refs.addAssistantView.setUnSelectList(this.allAssistantList)
          }
        })
      },
      remoteAssistant (array, item) {
        for (let i = 0; i < array.length; i++) {
          let tmp = array[i]
          if (tmp.Id === item.Id) {
            array.splice(i, 1)
            return
          }
        }
      },
      searchKeyByArray (key, array) {
        let resArray = []
        for (let i = 0; i < array.length; i++) {
          let item = array[i]
          if (item.Name.indexOf(key) >= 0 || item.Mobile.indexOf(key) >= 0) {
            resArray.push(item)
          }
        }
        return resArray
      },
      formatDate (fmt, dateStr) {
        let date = new Date(dateStr)
        let ret
        let opt = {
          'Y+': date.getFullYear().toString(),
          'm+': (date.getMonth() + 1).toString(),
          'd+': date.getDate().toString(),
          'H+': date.getHours().toString(),
          'M+': date.getMinutes().toString(),
          'S+': date.getSeconds().toString()
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
          };
        };
        return fmt
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/AddDoubleTeaLiveComponent.vue